module.exports = __webpack_public_path__ + "img/diamond-black.63b2b65e.svg";